import qs from 'querystringify';

export default function () {
  return qs.parse(window.location.search).backgroundColor || 'white';
}
